export default "__VITE_ASSET__Cma2ocew__"